import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromEquipment from '../fromEquipment.barrel';
import { EquipmentService } from 'src/app/services/equipment.service';
import { catchError, map, of, switchMap, tap, withLatestFrom } from 'rxjs';
import { Store } from '@ngrx/store';
import { odataParamsFactory } from '@tdw/core';


@Injectable()
export class EquipmentEffects {


  constructor(
    private actions$: Actions,
    private equipmentService: EquipmentService,
    private store: Store<fromEquipment.State>
  ) { }

  loadTapSizes$ = createEffect(() => this.actions$.pipe(
    ofType(fromEquipment.loadTapSizes),
    switchMap(action => this.equipmentService.loadHotTapSizes()
      .pipe(
        tap(res => console.log(res)),
        map(res => fromEquipment.loadTapSizesSuccess({ res })),
        catchError(error => of(fromEquipment.loadTapSizesFail({ error })))))
  ));

  loadTapMachines$ = createEffect(() => this.actions$.pipe(
    ofType(fromEquipment.loadTappingMachines),
    switchMap(action => this.equipmentService.loadEquipmentProducts(odataParamsFactory({ filter: 'equipmentTypeID in (1,2)' }))
      .pipe(map(res => {
        return fromEquipment.loadTappingMachinesSuccess({ res: res.value || [] })
      }),
        catchError(error => of(fromEquipment.loadTappingMachinesFail({ error }))))
    )
  ));

  updateFilter$ = createEffect(() => this.actions$.pipe(
    ofType(fromEquipment.updateFilter),
    map(action => fromEquipment.loadEquipmentTapInformation())
  ));

  loadTapInformation$ = createEffect(() => this.actions$.pipe(
    ofType(fromEquipment.loadEquipmentTapInformation),
    withLatestFrom(this.store.select(fromEquipment.selectActiveFilter)),
    switchMap(([action, filt]) => this.equipmentService.loadTapInformation(filt)
      .pipe(
        map(res => fromEquipment.loadEquipmentTapInformationSuccess({ result: res })),
        catchError(error => of(fromEquipment.loadEquipmentTapInformationFail({ error })))))));
}
